<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent :width="800">
        <v-card class="mt-3 pa-1">
            <Title title="通知の詳細">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>通知日時</th>
                            <th>結果</th>
                            <th>原因</th>
                            <th>対応</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="notification in alarmHistory.history.notifications" :key="notification.seqNo" :class="notificationColor(notification)">
                            <td>
                                {{(new Date(notification.time)).toFormatString("yyyy-MM-dd HH:mm:ss")}}
                            </td>
                            <td>
                                {{notificationResult(notification)}}
                            </td>
                            <td>
                                {{notificationFailedReason(notification)}}
                            </td>
                            <td>
                                {{notificationFailedAction(notification)}}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton
        },
        data: function () {
            return {
                isView: false,
                alarmHistory: null
            }
        },
        computed: {
            notificationColor: function () {
                return function (notification) {
                    switch (notification.result) {
                        case 1:
                            return "blue--text"
                        case 2:
                            return "red--text"
                    }
                }
            },
            notificationResult: function () {
                return function (notification) {
                    switch (notification.result) {
                        case 1:
                            return "成功"
                        case 2:
                            return "失敗"
                    }
                }
            },
            notificationFailedReason: function () {
                return function (notification) {
                    switch (notification.type) {
                        case 1:
                            switch (notification.result) {
                                case 1:
                                    return ""
                                case 2:
                                    var reason = ""
                                    switch (notification.failedContent.result) {
                                        case 1:
                                            reason = "未応答"
                                            break;
                                        case 2:
                                            reason = "話し中"
                                            break;
                                        case 3:
                                            reason = "番号違い"
                                            break;
                                        case 4:
                                            reason = "キャンセル"
                                            break;
                                    }
                                    return reason + "(" + notification.failedContent.failedNum + "回目)"
                            }
                            break;
                        case 11:
                            switch (notification.result) {
                                case 1:
                                    return ""
                                case 2:
                                    return notification.failedContent.error
                            }
                            break;
                    }
                }
            },
            notificationFailedAction: function () {
                return function (notification) {
                    switch (notification.type) {
                        case 1:
                            switch (notification.result) {
                                case 1:
                                    return ""
                                case 2:
                                    var action = ""
                                    switch (notification.failedContent.action) {
                                        case 1:
                                            action = "再通知"
                                            break;
                                        case 2:
                                            action = "再通知無し"
                                            break;
                                    }
                                    return action
                            }
                            break;
                        case 11:
                            switch (notification.result) {
                                case 1:
                                    return ""
                                case 2:
                                    return "再通知無し"
                            }
                            break;
                    }
                }
            }
        },
        methods: {
            /**
             * このダイアログを表示
             */
            show: function (alarmHistory) {
                this.alarmHistory = alarmHistory
                this.isView = true
            }
        }
    }
</script>
